import { type ArrayFieldTitleProps, titleId } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const ArrayFieldTitleTemplate = ({
  title,
  fieldPathId
}: ArrayFieldTitleProps) => (
  <Mtds.Heading data-size='xs' as='h4' id={titleId(fieldPathId)}>
    {title}
  </Mtds.Heading>
)
